/*=========================================================================================
  File Name: moduleAuthState.js
  Description: Auth Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


// import auth from "@/auth/authService";
import moment from 'moment'


export default {
    isUserLoggedIn: () => {
        let isAuthenticated = false;

        if (localStorage.getItem('accessToken') && localStorage.getItem('tokensExpiry'))
        {
            if (moment().isAfter(localStorage.getItem('tokensExpiry')))
                isAuthenticated = false
            else
                isAuthenticated = true
        }   
        else
            isAuthenticated = false

        return (isAuthenticated)
    },
}
